export default "__VITE_ASSET__RUMNfOTw__"